import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { redirectedLogin } from "../../redux/actions/authActions";

const Redirected = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    console.log(params);
    setLoading(true);
    dispatch(redirectedLogin(params?.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    console.log(data);
    navigate("/dashboard");
  };
  const onError = (err) => {
    console.log(err);
  };

  return <div>Redirecting....</div>;
};

export default Redirected;
